import { makeAutoObservable } from 'mobx'
import { type IIconProps } from 'shared/ui'

export type IFlowActionStoreProps<T = string> = {
  type: T
  edgeType?: string
  name: string
  parentId: string
  childId?: string
  defaultHeight?: number
  defaultWidth?: number
  iconProps?: IIconProps
  id: string
  allowedBeforeActions?: T[]
  allowedNextActions?: T[]
  allowedNextActionsByBranchIndex?: T[][]
}

export class FlowActionStore<T = string> {
  id
  type: T
  edgeType: string
  name: string
  iconProps: IIconProps | null
  parentId: string
  defaultHeight: number
  defaultWidth: number
  allowedBeforeActions: IFlowActionStoreProps<T>['allowedNextActions'] | null
  allowedNextActions: IFlowActionStoreProps<T>['allowedNextActions'] | null
  allowedNextActionsByBranchIndex: T[][] | null

  constructor({
    type,
    edgeType,
    name,
    iconProps,
    parentId,
    childId,
    defaultHeight = 72,
    defaultWidth = 240,
    id,
    allowedBeforeActions,
    allowedNextActions,
    allowedNextActionsByBranchIndex,
  }: IFlowActionStoreProps<T>) {
    this.type = type
    this.edgeType = edgeType || 'customEdge'
    this.name = name
    this.iconProps = iconProps || null
    this.parentId = parentId
    this.defaultHeight = defaultHeight
    this.defaultWidth = defaultWidth
    this.id = id
    this.allowedBeforeActions = allowedBeforeActions || null
    this.allowedNextActions = allowedNextActions || null
    this.allowedNextActionsByBranchIndex = allowedNextActionsByBranchIndex || null
    if (childId) {
      this.addNextId(childId)
    }
    makeAutoObservable(this)
  }

  private _nextIds: Set<string> = new Set()
  get nextIds() {
    return Array.from(this._nextIds)
  }

  get nextId() {
    if (this.nextIds.length === 1) {
      return this.nextIds[0]
    }
  }
  addNextId = (id: string) => {
    this._nextIds.add(id)
  }
  removeNextId = (id: string) => {
    this._nextIds.delete(id)
  }

  replaceNextId = (oldId: string, newId: string) => {
    this._nextIds = new Set(Array.from(this._nextIds).map((id) => (id === oldId ? newId : id)))
  }

  setParentId = (id: string) => {
    this.parentId = id
  }
}
